import {Grid, Box, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {LogoTextWhite} from 'components/icons/icons';
import {PSingleLine} from 'components/TypographyShortcuts';

const useStyles = makeStyles(theme => ({
    insert: {
        border: '1px solid lightgray',
        textAlign: 'center',
        margin: 'auto',
        paddingTop: '0.5em',
        maxWidth: '600px',
    },
    descriptionText: {
        color: theme.palette.primary.main,
        minWidth: '70%',
    },
    singleLine: {
        margin: 'auto',
    },
    paraContainer: {
        margin: '2em auto',
    },
}));

const FocusThankYou = () => {
    const classes = useStyles();

    return (
        <Box className={classes.insert}>
            <Grid container direction='column' alignItems='center'>
                <Grid item style={{marginBottom: '1em'}}>
                    <LogoTextWhite width='60%' />
                </Grid>
                <Grid item>
                    <Box className={classes.descriptionText}>
                        <Typography variant='h4'>
                            Perfect Application
                        </Typography>

                        <Grid
                            container
                            direction='column'
                            alignItems='flex-start'
                            style={{marginTop: '2em'}}
                        >
                            <Grid item xs={2}></Grid>
                            <Grid item xs={10} className={classes.singleLine}>
                                <PSingleLine>
                                    Great. You are all set.
                                </PSingleLine>
                            </Grid>

                            <Grid
                                container
                                key=''
                                spacing={1}
                                className={classes.paraContainer}
                            >
                                <Grid item xs={10} style={{margin: 'auto'}}>
                                    We will review your application and be in
                                    contact with you via the email you used for
                                    your MM-SEAS account.
                                </Grid>
                                <Grid
                                    item
                                    xs={10}
                                    style={{margin: '.5em auto'}}
                                >
                                    We'll put together a perfect application,
                                    calculate and cover USCG Fees for you, and
                                    charge your card on file $299! (If you
                                    already paid the USCG fees yourself, you'll
                                    be charged $199.)
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default FocusThankYou;
